import React, { useEffect, useState } from 'react';
import Content from '../../../../layout/content/Content';
import FeatureUnderDevelopment from '../../../loaders/FeatureUnderDevelopment';
import Head from '../../../../layout/head/Head';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent, Row } from '../../../../components/Component';
import { useDispatch } from 'react-redux';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { addThreeDots, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import moment from 'moment';
import { TENANT_RETRIEVE_PROMOTIONS_AUDIT_TRAILS_API } from '../../../../api/api_data';
import { fail_retrieve_tenant_audit_trails, loading_retrieve_tenant_audit_trails, reset_retrieve_tenant_audit_trails, success_retrieve_tenant_audit_trails } from '../../../../reducers/auth_tenant/retrieve_tenant_audit_trails_Slice';
import { RETRIVE_AUDIT_TRAILS_ERROR_MSG, RETRIVE_AUDIT_TRAILS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import CardTabs from '../../../components/cards/CardTabs';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import * as app_consts from "../../../../utils/app_consts";
import { Badge, Modal, ModalBody, ModalHeader } from 'reactstrap';
import LabelText from '../../../components/text/LabelText';
import { Link } from 'react-router-dom';
import AuthTenantNoData from '../../../error/AuthTenantNoData';

const PromotionsAuditTrails = ({ tenant_info, user_info }) => {

 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const [audit_trails, setAuditTrails] = useState([]);
 const [current_page_data, setCurrentPageData] = useState([]);
 const dispatch = useDispatch();
 const [itemPerPage, setItemPerPage] = useState(10);
 const [currentPage, setCurrentPage] = useState(1);
 const [selected_audit, setSelectedAudit] = useState("");
 const [audit_trails_modal, setAuditTrailsModal] = useState(false);
 const [searchTerm, setSearchTerm] = useState("");
 const [sm, updateSm] = useState(false);


 useEffect(() => {
  retrieve_audit_trails();
 }, []);


 const retrieve_audit_trails = () => {
  setError("");
  setLoading(true);
  // Retrieve Products
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_audit_trails, success_retrieve_tenant_audit_trails, fail_retrieve_tenant_audit_trails, RETRIVE_AUDIT_TRAILS_ERROR_MSG, RETRIVE_AUDIT_TRAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTIONS_AUDIT_TRAILS_API}`));
 };

 const retrieve_tenant_audit_trails_listner = useSelector((state) => state.retrieve_tenant_audit_trails.retrieve_tenant_audit_trails);

 useEffect(() => {
  if (retrieve_tenant_audit_trails_listner.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_audit_trails_listner.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (retrieve_tenant_audit_trails_listner.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(retrieve_tenant_audit_trails_listner.message);
     messageToast(retrieve_tenant_audit_trails_listner.message, app_consts.FAIL);
    } else if (retrieve_tenant_audit_trails_listner.status === app_consts.SUCCESS)
    {
     setAuditTrails(retrieve_tenant_audit_trails_listner.data);
     setCurrentPageData(retrieve_tenant_audit_trails_listner.data);
     const timer = setTimeout(() => {
      setLoading(false);
     }, 1000);

     return () => clearTimeout(timer); // cleanup in case the component unmounts
    }
    dispatch(reset_retrieve_tenant_audit_trails());
   }
  }
 }, [retrieve_tenant_audit_trails_listner]);

 // Change Page
 const paginate = (pageNumber) => setCurrentPage(pageNumber);

 // Calculate the start and end index for the current page
 const startIndex = (currentPage - 1) * itemPerPage;
 const endIndex = startIndex + itemPerPage;

 // UseEffect for Search 
 useEffect(() => {
  filtered_audit_trails(searchTerm);
 }, [searchTerm]);

 const filtered_audit_trails = (searchItem) => {
  if (searchItem)
  {
   let displayedAuditTrails;

   displayedAuditTrails = audit_trails?.filter((item) => {
    const combinedParams = [
     item?.user?.first_name,
     item?.user?.last_name,
     item?.user?.first_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : "--",
     item?.audit_trail?.message,
     item?.audit_trail?.audit_type,
     item?.audit_trail?.inserted_at ? moment(item?.audit_trail?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--",
     item?.audit_trail?.status?.replace(/_/g, ' ').toUpperCase(),
    ]
     .join(" ")
     .toLowerCase();

    return combinedParams.includes(searchItem.toLowerCase());
   }).slice(startIndex, endIndex);

   setCurrentPageData(displayedAuditTrails);
  } else
  {
   setCurrentPageData(audit_trails);
  }
 };

 // Get current list, pagination
 const indexOfLastItem = currentPage * itemPerPage;
 const indexOfFirstItem = indexOfLastItem - itemPerPage;
 const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

 const view_audit_trail = (audit_trail_id) => {
  setAuditTrailsModal(true);
  // Filter Audit
  const filtered_audit = audit_trails?.filter((audit) => audit?.audit_trail?.id === audit_trail_id);
  setSelectedAudit(filtered_audit[0]);
 };

 const close_modal = () => {
  setAuditTrailsModal(false);
  setSelectedAudit("");
 };


 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Audit Trails` : "Audit Trails"} />
   <Content>
    <BlockHead size="sm">
     <BlockBetween>
      <BlockHeadContent>
       <BlockTitle page>Audit Trails</BlockTitle>
       <BlockDes className="text-soft">
        <p>List is Limited to 1000 Audit Trails.</p>
       </BlockDes>
       {!(loading) && (
        <div className="mt-2">
         <Link
          onClick={(e) => {
           e.preventDefault();
           retrieve_audit_trails();
          }}
         >
          <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
           <span>Refresh List</span>
          </Button>
         </Link>
        </div>
       )}
      </BlockHeadContent>
      <BlockHeadContent>
       <div className="toggle-wrap nk-block-tools-toggle">
        <a
         href="#more"
         className="btn btn-icon btn-trigger toggle-expand me-n1"
         onClick={(ev) => {
          ev.preventDefault();
          updateSm(!sm);
         }}
        >
         <Icon name="more-v"></Icon>
        </a>
        <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
         <ul className="nk-block-tools g-3">
          <li>
           <div className="form-control-wrap">
            <div className="form-icon form-icon-right">
             <Icon name="search"></Icon>
            </div>
            <input
             type="text"
             className="form-control"
             id="default-04"
             value={searchTerm}
             onChange={e => setSearchTerm(e.target.value)}
             placeholder="Search for Audit Trail"
            />
           </div>
          </li>
         </ul>
        </div>
       </div>
      </BlockHeadContent>
     </BlockBetween>
    </BlockHead>
    {
     loading ?
      <>
       <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Audit Trails..." />
      </>
      :
      <>
       {
        error ?
         <>
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
         </>
         :
         <>
          {
           audit_trails && audit_trails?.length > 0 ?
            <>
             <Block>
              <div className="nk-tb-list is-separate is-medium mb-3">
               <DataTableHead className="nk-tb-item">
                <DataTableRow>
                 <span className="sub-text">User</span>
                </DataTableRow>
                <DataTableRow size="mb">
                 <span className="sub-text">Message</span>
                </DataTableRow>
                <DataTableRow size="mb">
                 <span className="sub-text">Audit Type</span>
                </DataTableRow>
                <DataTableRow size="md">
                 <span className="sub-text">Status</span>
                </DataTableRow>
                <DataTableRow size="lg">
                 <span className="sub-text">Timestamp</span>
                </DataTableRow>
                <DataTableRow size="lg">
                 <span className="sub-text">Action</span>
                </DataTableRow>
               </DataTableHead>
               {currentItems.length > 0
                ? currentItems.map((item) => (
                 <DataTableItem key={item.id}>
                  <DataTableRow>
                   <Link to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`}>
                    <div className="user-card">
                     <div className="user-info">
                      <span className="tb-lead">
                       {item?.user?.first_name ? `${item?.user?.first_name} ${item?.user?.last_name}` : "--"}<span className="dot dot-success d-md-none ms-1"></span>
                      </span>
                     </div>
                    </div>
                   </Link>
                  </DataTableRow>
                  <DataTableRow>
                   <span>{item?.audit_trail?.message ? addThreeDots(item?.audit_trail?.message, 60) : "--"}</span>
                  </DataTableRow>
                  <DataTableRow>
                   <span>{item?.audit_trail?.audit_type?.toUpperCase() || "--"}</span>
                  </DataTableRow>
                  <DataTableRow size="md">
                   <span className="tb-odr-status">
                    <Badge
                     color={
                      item?.audit_trail?.status === app_consts.SUCCESS_LOWER
                       ? "success"
                       : item?.audit_trail?.status === app_consts.REQUEST_LOWER
                        ? "warning"
                        : "danger"
                     }
                     className="badge-dot"
                    >
                     {item?.audit_trail?.status?.toUpperCase() || "--"}
                    </Badge>
                   </span>
                  </DataTableRow>
                  <DataTableRow>
                   <span>{item?.audit_trail?.inserted_at ? moment(item?.audit_trail?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                  </DataTableRow>
                  <DataTableRow className="nk-tb-col-tools">
                   <div className="tb-odr-btns d-none d-sm-inline">
                    <Link /* to={`/${tenant_info.url_prefix}/employees/${item?.account?.mobile_number}`} */>
                     <Button color="primary" size="sm" className="btn btn-dim" onClick={() => view_audit_trail(item?.audit_trail?.id)}>
                      View
                     </Button>
                    </Link>
                   </div>
                   <Button className="btn-pd-auto d-sm-none" onClick={() => view_audit_trail(item?.audit_trail?.id)}>
                    <Icon name="chevron-right"></Icon>
                   </Button>
                  </DataTableRow>
                 </DataTableItem>
                ))
                : null}
              </div>
              {currentItems?.length > 0 && (
               <div className="mt-3">
                <PaginationComponent
                 itemPerPage={itemPerPage}
                 totalItems={current_page_data?.length}
                 paginate={paginate}
                 currentPage={currentPage}
                />
               </div>
              )}
             </Block>
            </>
            :
            <>
             <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Audit Trails Found"} />
            </>
          }
         </>
       }

       {/* Page Modal */}
       <Modal isOpen={audit_trails_modal} toggle={close_modal} className="modal-dialog-centered" size={"lg"}>
        <ModalHeader toggle={close_modal}>Audit Trail Details</ModalHeader>
        <ModalBody>
         <Row className="g-4">
          <LabelText text={selected_audit?.user?.first_name ? `${selected_audit?.user?.first_name} ${selected_audit?.user?.last_name}` : "--"} label="User" />

          <LabelText text={selected_audit?.audit_trail?.message || "--"} label="Message" />
          <LabelText text={selected_audit?.audit_trail?.audit_type?.toUpperCase() || "--"} label="Audit Type" />
          <LabelText
           text={selected_audit?.audit_trail?.status?.toUpperCase() || "--"}
           label="Status"
           badgeStat
           badgeColor={
            selected_audit?.audit_trail?.status === app_consts.SUCCESS_LOWER
             ? "success"
             : selected_audit?.audit_trail?.status === app_consts.REQUEST_LOWER
              ? "warning"
              : "danger"
           }
          />
          <LabelText text={selected_audit?.audit_trail?.inserted_at ? moment(selected_audit?.audit_trail?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"} label="Timestamp" />
          {selected_audit?.audit_trail?.data &&
           (
            <>
             <div className="mt-4 ">
              <BlockHead>
               <BlockTitle tag="h6">Audit Data</BlockTitle>
              </BlockHead>
             </div>
             {selected_audit?.audit_trail?.data &&
              Object.entries(selected_audit.audit_trail.data)
               .filter(([_, value]) => !Array.isArray(value)) // Skip arrays
               .map(([key, value]) => (
                <LabelText key={formatToSentenceCase(key)} text={String(value)} label={key} />
               ))}
            </>
           )
          }
         </Row>
        </ModalBody>
       </Modal>

      </>
    }
   </Content>
  </>
 );
};

export default PromotionsAuditTrails;